import apiClient from "./apiClient";

const toIsoString = (value) => {
  if (!value) return value;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(`${value}T00:00:00Z`).toISOString();
  }
  const asDate = value instanceof Date ? value : new Date(value);
  return Number.isNaN(asDate.getTime()) ? value : asDate.toISOString();
};

const normalizeActionPayload = (data) => {
  const payload = { ...data };
  if ("due_date" in payload) {
    payload.due_date = payload.due_date ? toIsoString(payload.due_date) : null;
  }
  return payload;
};

export const getActions = (params) => apiClient.get("/actions", { params });
export const getActionsHealthSnapshot = (params) => apiClient.get("/actions/health", { params });
export const listActionCategories = () => apiClient.get("/actions/categories");

export const createAction = (data) => apiClient.post("/actions", normalizeActionPayload(data));

export const getAction = (actionId) => apiClient.get(`/actions/${actionId}`);

export const updateAction = (actionId, data) => apiClient.put(`/actions/${actionId}`, normalizeActionPayload(data));

export const deleteAction = (actionId) => apiClient.delete(`/actions/${actionId}`);

export const listActionsByRisk = (riskId) => apiClient.get(`/actions/by-risk/${riskId}`);
export const listActions = (params) => apiClient.get("/actions", { params });

export const listActionsByControl = (controlId) => apiClient.get(`/actions/by-control/${controlId}`);

export const listRiskActions = (riskId) => apiClient.get(`/risks/${riskId}/actions`);

export const getActionHistory = (actionId) => apiClient.get(`/actions/${actionId}/history`);

export const exportActionsHealthPdf = (payload) =>
  apiClient.post("/actions/health/export/pdf", payload, {
    responseType: "blob",
  });

export const addActionNote = (actionId, data) => apiClient.post(`/actions/${actionId}/notes`, data);

export const updateActionNote = (noteId, data) => apiClient.put(`/actions/notes/${noteId}`, data);

export const deleteActionNote = (noteId) => apiClient.delete(`/actions/notes/${noteId}`);

export const addActionAttachment = (actionId, data) => apiClient.post(`/actions/${actionId}/attachments`, data);
